import React from 'react';
// Components
import InternalExternalLink from '../Link';
import SVG from 'react-inlinesvg';

// Interfaces
import { Image as ImageInterface } from '../../interfaces/image';

function Image({ data }: { data: ImageInterface }) {
  const { image, mobileImage, link, lazyLoad, renderImageAsSvg, placement, extraClasses } = data;

  return (
    <React.Fragment>
      {link ? (
        <InternalExternalLink link={link}>
          <img
            className={`cl-image cl-image--offset-${placement || 'normal'} ${extraClasses || ''}`}
            src={image.file.url}
            width={image.file.details.image.width}
            height={image.file.details.image.height}
            alt={image.description ? image.description : 'Fill Image Description'}
            loading={lazyLoad ? 'lazy' : 'eager'}
          />
        </InternalExternalLink>
      ) : renderImageAsSvg ? (
        <div className={`cl-svg cl-image--offset-${placement || 'normal'} ${extraClasses || ''}`}>
          <SVG
            src={image.file.url}
            // cacheRequests={true}
            title={image.title ? image.title : 'Fill Image Description'}
            description={image.description ? image.description : 'Fill Image Description'}
            width={image.file.details.image.width}
            height={image.file.details.image.height}
          />
        </div>
      ) : (
        <picture
          className={`cl-image cl-image--offset-${placement || 'normal'} ${extraClasses || ''}`}
        >
          {mobileImage && <source srcSet={mobileImage.file.url} media='(max-width: 768px)' />}
          <img
            src={image.file.url}
            width={image.file.details.image.width}
            height={image.file.details.image.height}
            alt={image.description ? image.description : 'Fill Image Description'}
            loading={lazyLoad ? 'lazy' : 'eager'}
          />
        </picture>
      )}
    </React.Fragment>
  );
}

export default Image;
